import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { ObjectiveFlag, AddButton, DBTextAreaObjective } from '_components';
import styles from './Common.module.css'
import { ObservationPalpationEntry } from './ObservationPalpationEntry';

class ObservationPalpationLocation extends React.Component {

    addPalpation() {
        this.props.addChildRow(this.props.noteId, 'PTOBJECTIVEPALP', 'PA', 'PAOONO', this.props.oono);
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.palpEntries.length > 0} mopno={this.props.mopno} flagText='Palpation' />
                    <div className={styles.add_button} >
                        <AddButton title='Add Palpation Entry...' size='extra-small' onClick={() => this.addPalpation()} />
                    </div>
                    {this.props.palpEntries.length === 0 &&
                        <div className={styles.tip}>Click to add entry</div>
                    }
                    {this.props.palpEntries.length > 0 &&
                        <span>
                            <div className={styles.palp_column_1_header}>Body Region</div>
                            <div className={styles.palp_column_2_header}>Palpation</div>
                            <div className={styles.palp_column_3_header}>Comments</div>
                        </span>
                    }
                </div>
                {Object.keys(this.props.palpEntries)
                    .map(key => {
                        const result = this.props.palpEntries[key];
                        return (
                            <ObservationPalpationEntry key={result.PANO} id={result.PANO} />
                        )
                    })
                }

                <div className={styles.textarea_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.commentsFlagged} mopno={this.props.mopno} flagText='Palpation - Description' />
                    <label className={styles.textarea_label}>Description</label>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPALPCOMMENTS'
                        className={styles.textarea}
                        onChange={() => this.objValueChanged()}
                    />
                </div>



            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        noteId: noteId,
        oono: oono,
        palpEntries: Object.keys(state.entities.notes.PTOBJECTIVEPALP)
            .filter(key => { return state.entities.notes.PTOBJECTIVEPALP[key].PAOONO === oono })
            .sort((a, b) => state.entities.notes.PTOBJECTIVEPALP[a].PANO - state.entities.notes.PTOBJECTIVEPALP[b].PANO)
            .map(key => state.entities.notes.PTOBJECTIVEPALP[key]),
        objUpdated,
        commentsFlagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOPALPCOMMENTS ? true : false
    };
}

const connectedObservationPalpationLocation = connect(mapStateToProps, mapDispatchToProps)(ObservationPalpationLocation);
export { connectedObservationPalpationLocation as ObservationPalpationLocation };


